export default __webpack_public_path__ + "../staticImages/sprite-post_ch-2x.png";